import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { Profile } from '@app/profile/profile';
import { ProfileOverviewFacade } from '@app/profile/components/profile-overview-v2/profile-overview.facade';
import { WebEnvironmentService } from '@app/shared/services/web-environment.service';
import { ProfileOverviewViewModel } from './profile-overview.model';

const CONTENT_KEYS = [
  'Core_Empty_Image_Alt',
  'dgProfileOverview_OverviewEmptyStateTitle',
  'dgProfileOverview_OverviewEmptyStateText',
  'dgProfileOverview_OverviewCompleteWizardButton',
  'dgProfileOverview_OverviewSkillsTitle',
  'dgProfileOverview_OverviewExperienceTitle',
  'dgProfileOverview_OverviewAchievementsTitle',
  'dgProfileOverview_OverviewLearningTitle',
  'dgProfileOverview_OverviewNotProvidedTitle',
  'dgProfileOverview_NonOwnerEmptyStateTitle',
];

const ROOT = '/content/img/emptystate';
const SVG_EMPTY_OWNER = `profile-settings`;
const SVG_EMPTY_OVERVIEW = `profile-overview-empty-state`;

const buildLookup =
  (webEnvironmentService: WebEnvironmentService) => (key: string) => {
    return webEnvironmentService.getBlobUrl(`${ROOT}/${key}.svg`, true);
  };

@Component({
  selector: 'dgx-profile-overview-v2',
  templateUrl: './profile-overview.component.html',
  styleUrls: ['./profile-overview.component.scss'],
})
export class ProfileOverviewComponent {
  @Input() public owner: Profile;
  @Input() public privacyId: number;

  public readonly CLASS_NAME = 'ProfileOverviewComponentV2';
  public i18n = this.translate.instant(CONTENT_KEYS);

  public maxSkills: number = 6;

  public nonOwnerEmptyImageUrl: string;
  public emptyImageUrl: string;
  public get nonOwnerEmptyStateText(): string {
    return this.translate.instant('dgProfileOverview_NonOwnerEmptyStateBody', {
      firstName: this.owner.name.split(' ')[0],
    });
  }

  public vm$: Observable<ProfileOverviewViewModel>;

  constructor(
    private facade: ProfileOverviewFacade,
    private router: Router,
    private translate: TranslateService,
    private webEnvironmentService: WebEnvironmentService
  ) {
    this.vm$ = this.facade.vm$;

    const urlFor = buildLookup(this.webEnvironmentService);
    this.nonOwnerEmptyImageUrl = urlFor(SVG_EMPTY_OWNER);
    this.emptyImageUrl = urlFor(SVG_EMPTY_OVERVIEW);
  }

  public goToWizard(): void {
    this.router.navigateByUrl('/getstarted/welcome');
  }
}
